import { useState } from 'react';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  Button
} from 'reactstrap';
import { CalenderIcon } from '../../Icon';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import FileSaver from 'file-saver';
import Loader from '../../commons/Loader';
import { NewDownloadIcon, NewDownloadIconActive } from '../../../assets/images';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { downloadInwardsReportsApi, downloadOutwardsReportsApi } from '../../../apis/gstModuleApis';
import { formatDate } from '../../../utils/commonFunctions';
import { FilterType, GstRadioTypes } from '../../../commonTypes/gstTypes';
import toast, { Toaster } from "react-hot-toast";

type AppProps = {
  type: string;
  clientCode: number;
  token: string | null;
  companyName: string;
  filters:any;
  sorting:GstRadioTypes | undefined;
  currentYear:number;
  text:string;
}

const DownloadGstrReports = ({
  type,
  clientCode,
  token,
  companyName,
  filters,
  sorting,
  currentYear,
  text
}: AppProps) => {

  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
  };

  const handleStartDate = (date: any) => {
    setStartDate(date)
    setEndDate(null)
  };



  const handleDownload = () => {
    setIsLoading(true);
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(false);
    if (type === 'outwards') {
      handlePrepareOutwardReportData();
    } else {
      handlePrepareInwardReportData();
    }
  };

  const handlePrepareInwardReportData = () => {
    let params:any = {
      token,
      search_term:text,
      client_code:clientCode,
      start_date:(!startDate || startDate=="Invalid date")?formatDate(`${currentYear}-04-01`) :  formatDate(startDate),
      end_date: (!endDate || endDate=="Invalid date")?formatDate(`${currentYear + 1}-03-31`):formatDate(endDate),
      gstr2a:filters?.gstr2a,
      gstr2b:filters?.gstr2b,
      seller_type:filters?.sellerType,
      whether_eligible:filters?.wheatherEligible,
      purchase_from_composition_dealer:filters?.purcahseFromCompositionDealer,
      sort_by:sorting?.unique_id,
      sort_order:sorting?._id
  }

    if (params && token) {
      handleDownloadInwardsReport(params);
    }
  };


  const handlePrepareOutwardReportData = () => {
    let params = {
      token,
      search_term: text,
      client_code:clientCode,
      start_date: (!startDate || startDate == "Invalid date") ? formatDate(`${currentYear}-04-01`) : formatDate(startDate),
      end_date: (!endDate || endDate == "Invalid date") ? formatDate(`${currentYear + 1}-03-31`) : formatDate(endDate),
      exports: filters?.exports,
      sez: filters?.sez,
      sez_tax_payment: filters?.sezTaxPayment,
      place_of_supply: filters?.placeOfSupply?.value,
      sales_type: filters?.salesType,
      sort_by:sorting?.unique_id,
      sort_order:sorting?._id
  }

    if (params && token) {
      handleDownloadOutwardsReport(params);
    }
  };

  



  const handleDownloadOutwardsReport = (params: any) => {
    let reportName = `${companyName ? companyName : 'reports'}_outwards_${formatDate(startDate)}_to_${formatDate(endDate)}.xlsx`;

    downloadOutwardsReportsApi(params).then((response) => {
      setIsLoading(false);
      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8" })
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handleDownloadInwardsReport = (params: any) => {
    let reportName = `${companyName ? companyName : 'reports'}_inwards_${formatDate(startDate)}_to_${formatDate(endDate)}.xlsx`;
      downloadInwardsReportsApi(params).then((response) => {
      setIsLoading(false);
      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8" })
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  }

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="download-report-btn"
        style={showDropdown ? {
          color: "#dd4433",
          backgroundColor: "#fff6f5"
        } : {}}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={<Tooltip id="button-view-download-invoice">
            Download Reports
          </Tooltip>}>

          <DropdownToggle
            caret
            // color="secondary"
            outline
            style={showDropdown ? {
              color: "#dd4433",
              backgroundColor: "#fff6f5"
            } : { border: "1px solid#bfcbe1" }}
          >
            {/* <DownloadIcon />  */}
            <img src={showDropdown ? NewDownloadIconActive : NewDownloadIcon} alt="download icon" />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="download-dropdown p-3">
            <h4>Download Report</h4>
        
            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>

                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={(date: any) => setEndDate(date)}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">

                <button className="btn btn-outline-secondary mr-3" onClick={handleCancel}>Cancel</button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={startDate && endDate  ? false : true}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {isLoading && <Loader />}
      <Toaster />
    </>
  );
};

export default DownloadGstrReports;